import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { Button, Tooltip } from 'redpoints-front-components/index';

const ActionButton = ({ children, disabled, onClick }) => (
  <Button
    className="rp-shortener-resolution-btn reset-btn"
    disabled={disabled}
    onClick={onClick}
  >
    {children}
  </Button>
);

const ShortenerResolutionActionsButton = props => {
  const { disabled, title } = props;

  if (disabled) {
    return <ActionButton {...props} />;
  }

  return (
    <Tooltip overlayClassName="rp-shortener-resolution-tooltip" title={title}>
      <span>
        <ActionButton {...props} />
      </span>
    </Tooltip>
  );
};

ShortenerResolutionActionsButton.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  title: PropTypes.string,
};

export default memo(ShortenerResolutionActionsButton);
